import chatAvatar from "../../shared/assets/img/chat-avatar.svg";
import { motion } from "framer-motion";

interface OllieChatAvatarProps {
    animateLoading?: boolean;
    endAnimationText?: string;
    showEndAnimation?: boolean;
    onEndAnimationComplete?: () => void;
}

export const OllieChatAvatar = ({
    animateLoading = false,
    endAnimationText,
    showEndAnimation = false,
    onEndAnimationComplete
}: OllieChatAvatarProps) => {
    return (
        <div className="relative">
            <div className="flex items-center font-recoleta">
                <div className="relative w-8 h-8">
                    <img src={chatAvatar} alt="Chat Avatar" className="w-8 h-8" />
                    {animateLoading && (
                        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-osBlue-1 animate-spin"></div>
                    )}
                </div>
                <div className="-ml-2 text-sm border border-osBlack rounded-e-full px-2">Ollie</div>
            </div>

            {showEndAnimation && endAnimationText && (
                <motion.div
                    initial={{ y: -20, opacity: 0 }}
                    animate={{ y: [-20, 0, 0], opacity: [0, 1, 1] }}
                    transition={{ duration: 1.2, times: [0, 0.17, 1] }}
                    onAnimationComplete={onEndAnimationComplete}
                    className="absolute top-full mt-1 left-0 text-sm text-osGray-600 font-recoleta -z-1"
                >
                    {endAnimationText}
                </motion.div>
            )}
        </div>
    )
}